import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { trackConversion } from '../../lib/analytics';

const PlaybooksBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="playbooks-banner">
      <div className="container">
        <div className="playbooks-banner__inner">
          <div className="playbooks-banner__content">
            <span className="playbooks-banner__kicker">
              {t("playbooks_banner_kicker")}
            </span>
            <h3 className="playbooks-banner__title">
              {t("playbooks_banner_title")}
            </h3>
            <p className="playbooks-banner__description">
              {t("playbooks_banner_description")}
            </p>
          </div>
          <div className="playbooks-banner__actions">
            <Link
              to="/playbooks"
              className="z-btn z-btn-3"
              onClick={() => trackConversion("Playbooks Banner CTA")}
            >
              {t("playbooks_banner_cta")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlaybooksBanner;
